import React, { useEffect, useState } from 'react';
import { FullscreenModal } from '../../../common/fullscreenModal/FullscreenModal';
import {
  ButtonPrimary,
  DataTable,
  Loader,
  ModalContent,
  ModalHeader,
  IconTrash,
  Input,
  SelectInputSearch,
} from '@skf/bt-wind-rail-commonlibrary';
import { useTranslation } from 'react-i18next';
import style from './TurbineManagementFormulary.module.scss';
import { useToast } from '../../../../hooks/useToast';
import {
  TaxonomyCountryCustomer,
  TaxonomyCustomerAdmin,
  TaxonomySystemInfoAdmin,
  TaxonomySystemInfoAdminCompleted,
} from '../../../../store/taxonomy/types';
import { IOption } from '@skf/bt-wind-rail-commonlibrary/dist/components/form/types';
import { IndustryOptions } from '../industryNameEnum';
import {
  GetIndustryTaxonomyCustomer,
  GetTaxonomyCountriesCustomer,
  PostAddNeWindFarm,
  PostUpdateWindFarm,
} from '../../../../store/taxonomy/actions';
import { useDispatch, useSelector } from 'react-redux';
import { StoreState } from '../../../../store/store';
import {
  ITaxonomyCutomerState,
  ITaxonomyState,
} from '../../../../store/taxonomy/store';
import CreateGUID from '../../../../utils/guid';

interface ITurbineManagementFormularyProps {
  taxonomy?: TaxonomyCustomerAdmin;
  onClose: () => void;
  turbines?: TaxonomySystemInfoAdminCompleted[];
}

export const TurbineManagementFormulary: React.FunctionComponent<ITurbineManagementFormularyProps> = ({
  taxonomy,
  onClose,
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { addToast } = useToast();
  const [isFetching] = useState<boolean>(false);
  const [industryName, setIndustryName] = useState<string | undefined | number>(
    ''
  );
  const [ownerName, setOwnerName] = useState<string | undefined | number>('');
  const [ownerNameOptions, setOwnerNameOptions] = useState<IOption[]>([]);
  const [ownerId, setOwnerId] = useState<string | undefined | number>('');
  const [ownerIdOptions, setownerIdOptions] = useState<IOption[]>([]);
  const [plantContribution, setPlantContribution] = useState<
    string | undefined | number
  >('');
  const [siteCountryCode, setSiteCountryCode] = useState<
    string | undefined | number
  >('');
  const [siteCountryCodeOptions, setSiteCountryCodeOptions] = useState<
    IOption[]
  >([]);
  const [siteCountryDescription, setSiteCountryDescription] = useState<
    string | undefined | number
  >('');
  const [
    siteCountryDescriptionOptions,
    setSiteCountryDescriptionOptions,
  ] = useState<IOption[]>([]);
  const [siteAreaDescription, setSiteAreaDescription] = useState<
    string | undefined | number
  >('');
  const [plantId, setPlantId] = useState<string | undefined | number>('');
  const [plantCapacity, setPlantCapacity] = useState<
    undefined | number | string
  >(undefined);
  const [plantDescription, setPlantDescription] = useState<
    string | undefined | number
  >('');
  const { taxonomyCustomer } = useSelector<StoreState, ITaxonomyCutomerState>(
    (selector) => selector.taxonomyCustomer
  );
  const [_taxonomyCustomer, _setTaxonomyCustomer] = useState<
    TaxonomyCustomerAdmin[]
  >([]);
  const { taxonomyCountryCustomer } = useSelector<StoreState, ITaxonomyState>(
    (selector) => selector.taxonomyCountryCustomer
  );
  const [, _setTaxonomyCountryCustomer] = useState<TaxonomyCountryCustomer[]>(
    []
  );
  const [_turbines, _setTurbines] = useState<TaxonomySystemInfoAdmin[]>([]);
  const onClickClose = () => !isFetching && onClose();
  const [windFarmsCreated, setwindFarmsCreated] = useState<
    TaxonomyCustomerAdmin[]
  >([]);
  const borderOk = { border: `1px solid #c7cad0` };
  const borderError = {
    border: `1px solid red`,
    borderColor: `red !important`,
  };
  const [industryValidationColor, setIndustryValidationColor] = useState(false);
  const [ownerNameValidationColor, setOwnerNameValidationColor] = useState(
    false
  );
  const [ownerIdValidationColor, setOwnerIDValidationColor] = useState(false);
  const [
    siteCountryCodeValidationColor,
    setSiteCountryCodeValidationColor,
  ] = useState(false);
  const [
    siteCountryDescriptionValidationColor,
    setSiteCountryDescriptionValidationColor,
  ] = useState(false);
  const [
    siteAreaDescriptionValidationColor,
    setSiteAreaDescriptionValidationColor,
  ] = useState(borderOk);
  const [
    plantContriburionMarginValidationColor,
    setPlantContriburionMarginValidationColor,
  ] = useState(borderOk);
  const [plantIdValidationColor, setplantIdValidationColor] = useState(
    borderOk
  );
  const [
    plantCapacityValidationColor,
    setPlantCapacityValidationColor,
  ] = useState(borderOk);
  const [
    plantDescriptionValidationColor,
    setPlantDescriptionValidationColor,
  ] = useState(borderOk);
  const [newOwnerBool, setNewOwnerBool] = useState<boolean>(false);

  useEffect(() => {
    setPlantContriburionMarginValidationColor(borderOk);
    setPlantCapacityValidationColor(borderOk);
    if (taxonomy && taxonomy.taxonomySystemInfos) {
      _setTurbines(
        taxonomy.taxonomySystemInfos.filter(
          (e: TaxonomySystemInfoAdmin) =>
            e.systemInfoStatus === 'Draft' || e.systemInfoStatus === 'Confirmed'
        )
      );
      dispatch(GetIndustryTaxonomyCustomer(taxonomy.sourceFlag));
    }
  }, []);

  useEffect(() => {
    if (taxonomyCustomer) {
      _setTaxonomyCustomer(taxonomyCustomer);
      if (taxonomy !== undefined) {
        fillOwner(taxonomyCustomer);
        fillCountryList(taxonomyCustomer);
      }
      fillOwner(taxonomyCustomer);

      return;
    }
  }, [taxonomyCustomer]);

  useEffect(() => {
    if (taxonomyCountryCustomer) {
      _setTaxonomyCountryCustomer(taxonomyCountryCustomer);
      fillCountryList(taxonomyCountryCustomer);

      return;
    }

    dispatch(GetTaxonomyCountriesCustomer());
  }, [taxonomyCountryCustomer]);

  useEffect(() => {
    if (industryName === undefined || industryName === '') {
      setOwnerNameOptions([]);
      setownerIdOptions([]);
      setOwnerName('');
      setOwnerId('');
    }
  }, [industryName]);

  function compare(a, b) {
    if (a.siteCountryDescription < b.siteCountryDescription) {
      return -1;
    }

    if (a.siteCountryDescription > b.siteCountryDescription) {
      return 1;
    }
    return 0;
  }

  function fillCountryList(
    taxonomyCountryCustomerSTATE: TaxonomyCountryCustomer[]
  ) {
    if (siteCountryCodeOptions.length > 0) return;
    const countriesListCODEOption: IOption[] = [];
    const countriesListDESCOption: IOption[] = [];
    const countriesListAREAOption: IOption[] = [];
    let txCountryShorted: TaxonomyCountryCustomer[] = [];
    txCountryShorted = taxonomyCountryCustomerSTATE.sort(compare);
    txCountryShorted.forEach((x) => {
      countriesListCODEOption.push({
        label: x.siteCountryCode,
        labelToShow: x.siteCountryCode,
        value: x.siteCountryCode,
      });
      countriesListDESCOption.push({
        label: x.siteCountryDescription,
        labelToShow: x.siteCountryCode,
        value: x.siteCountryDescription,
      });
      countriesListAREAOption.push({
        label: x.siteCountryDescription,
        labelToShow: x.siteCountryCode,
        value: x.siteAreaDescription,
      });
    });

    setSiteCountryCodeOptions(countriesListCODEOption);
    setSiteCountryDescriptionOptions(countriesListDESCOption);
  }

  function handlePlantId(val: string) {
    setPlantId(val);
    setplantIdValidationColor(borderOk);
  }

  function handlePlantDescription(val: string) {
    setPlantDescription(val);
    setPlantDescriptionValidationColor(borderOk);
  }

  function handleIndustry(params: string | undefined | any) {
    setIndustryName(params);
    setIndustryValidationColor(false);
    if (params !== undefined) {
      dispatch(GetIndustryTaxonomyCustomer(params));
    }
    fillOwner(_taxonomyCustomer);
  }

  function createWindFarms() {
    if (windFarmsCreated && windFarmsCreated.length > 0) {
      const windfarmAddOk = () => {
        addToast({
          status: 'ok',
          message: t('addWindFarmOk'),
          timeout: 7000,
        });
      };
      const windfarmAddInProgress = () => {
        addToast({
          status: 'warning',
          message: t('addWindfarm'),
          timeout: 7000,
        });
      };
      const windfarmAddError = () => {
        addToast({
          status: 'danger',
          message: t('failedAddWindfarm'),
          timeout: 7000,
        });
      };
      dispatch(
        PostAddNeWindFarm(
          windFarmsCreated,
          windfarmAddOk,
          windfarmAddInProgress,
          windfarmAddError
        )
      );
      onClickClose();
    } else {
    }
  }

  function modifyWindFarms() {
    if (validateForm()) {
      const plantFieldsValidated = validatePlantFields();
      if (!plantFieldsValidated) return;

      if (taxonomy) {
        const taxonomyToModify: TaxonomyCustomerAdmin = taxonomy;
        if (ownerId) taxonomyToModify.companyId = ownerId?.toString();
        if (ownerName) taxonomyToModify.companyName = ownerName?.toString();
        if (siteCountryDescription)
          taxonomyToModify.siteCountryDescription = siteCountryDescription?.toString();
        if (siteCountryCode)
          taxonomyToModify.siteCountryCode = siteCountryCode?.toString();
        if (siteAreaDescription)
          taxonomyToModify.siteAreaDescription = siteAreaDescription?.toString();
        if (plantDescription)
          taxonomyToModify.plantUnitDescription = plantDescription?.toString();
        if (plantId) taxonomyToModify.plantUnitId = plantId?.toString();
        if (plantCapacity)
          taxonomyToModify.plantUnitCapacity = plantCapacity?.toString();
        if (plantContribution)
          taxonomyToModify.plantUnitContributionMargin = plantContribution.toString();

        taxonomyToModify.taxonomySystemInfos = _turbines;
        const plantIdToastr: string = plantId?.toString() || '';
        const modifyWindfarmOk = (): void => {
          addToast({
            status: 'ok',
            message: t('modifyWindFarmOk'),
            timeout: 7000,
          });
        };
        const modifyWindfarmInProgress = (): void => {
          addToast({
            status: 'warning',
            message: t('modifyWindfarm').replace('@', plantIdToastr),
            timeout: 7000,
          });
        };
        const modifyWindfarmFailed = (): void => {
          addToast({
            status: 'danger',
            message: t('failedUpdateWindfarm').replace('@', plantIdToastr),
            timeout: 7000,
          });
        };
        dispatch(
          PostUpdateWindFarm(
            [taxonomyToModify],
            modifyWindfarmOk,
            modifyWindfarmInProgress,
            modifyWindfarmFailed
          )
        );
        onClose();
      }
    }
  }

  function fillOwner(dataTaxonomyCustomer: TaxonomyCustomerAdmin[]) {
    const ownerNames: IOption[] = [];
    const ownerIds: IOption[] = [];
    dataTaxonomyCustomer?.map((d) => {
      if (!ownerNames.find((x) => x.value === d.companyName)) {
        ownerNames.push({
          label: d.companyName,
          labelToShow: d.companyName,
          value: d.companyName,
        });
      }
      if (!ownerIds.find((x) => x.value === d.companyId)) {
        ownerIds.push({
          label: d.companyId,
          labelToShow: d.companyId,
          value: d.companyId,
        });
      }
    });
    setOwnerNameOptions(ownerNames);
    setownerIdOptions(ownerIds);
    if (taxonomy) setValuesByDefault();
  }

  function setValuesByDefault() {
    setIndustryName(taxonomy?.sourceFlag);
    setOwnerId(taxonomy?.companyId);
    setOwnerName(taxonomy?.companyName);
    setSiteCountryCode(taxonomy?.siteCountryCode);
    setSiteCountryDescription(taxonomy?.siteCountryDescription);
    setSiteAreaDescription(taxonomy?.siteAreaDescription);
    setPlantId(taxonomy?.plantUnitId);
    setPlantCapacity(taxonomy?.plantUnitCapacity);
    setPlantDescription(taxonomy?.plantUnitDescription);
    setPlantContribution(taxonomy?.plantUnitContributionMargin);
  }

  function handleOwnerName(valueSelected: string | number | undefined) {
    setOwnerName(valueSelected);
    setOwnerNameValidationColor(false);
    setOwnerId(
      taxonomyCustomer?.find((x) => x.companyName === valueSelected)?.companyId
    );
    setOwnerIDValidationColor(false);
  }

  function handleOwnerId(valueSelected: string | number | undefined) {
    setOwnerId(valueSelected);
    setOwnerIDValidationColor(false);
    setOwnerName(
      taxonomyCustomer?.find((x) => x.companyId === valueSelected)?.companyName
    );
    setOwnerNameValidationColor(false);
  }

  function handleSiteCountryCode(value: string | number | undefined) {
    setSiteCountryCode(value);
    setSiteCountryDescription(
      taxonomyCountryCustomer?.find((x) => x.siteCountryCode === value)
        ?.siteCountryDescription
    );
    setSiteCountryCodeValidationColor(false);
    setSiteCountryDescriptionValidationColor(false);
    setSiteAreaDescription(
      taxonomyCountryCustomer?.find((x) => x.siteCountryCode === value)
        ?.siteAreaDescription
    );
    setSiteAreaDescriptionValidationColor(borderOk);
  }

  function handleSiteCountryDescription(value: string | number | undefined) {
    setSiteCountryDescription(value);
    setSiteCountryDescriptionValidationColor(false);
    setSiteCountryCode(
      taxonomyCountryCustomer?.find((x) => x.siteCountryDescription === value)
        ?.siteCountryCode
    );
    setSiteCountryCodeValidationColor(false);
    setSiteAreaDescription(
      taxonomyCountryCustomer?.find((x) => x.siteCountryDescription === value)
        ?.siteAreaDescription
    );
    setSiteAreaDescriptionValidationColor(borderOk);
  }

  function AddWindfarmButtonClick() {
    if (validateForm()) {
      const plantFieldsValidated = validatePlantFields();
      if (!plantFieldsValidated) return;

      let newWindFarm: any = {};
      if (taxonomyCustomer) {
        const restOfTaxonomyData = taxonomyCustomer.find(
          (x) =>
            x.industryDescription &&
            x.sectorCode &&
            x.sectorDescription &&
            x.industryCode &&
            x.segmentCode &&
            x.segmentDescription
        );

        if (restOfTaxonomyData) {
          newWindFarm = { ...restOfTaxonomyData };
        }

        newWindFarm.plantUnitContributionMargin = plantContribution
          ? +plantContribution
          : undefined;
        newWindFarm.plantUnitCapacity = plantCapacity
          ? plantCapacity
          : undefined;
        newWindFarm.plantUnitDescription = plantDescription
          ? plantDescription.toString()
          : undefined;
        newWindFarm.plantUnitId = plantId ? plantId.toString() : undefined;
        newWindFarm.plantUnitKey = CreateGUID();
        newWindFarm.taxonomySystemInfos = [];
        if (ownerName) newWindFarm.companyName = ownerName.toString();
        if (ownerId) newWindFarm.companyId = ownerId.toString();
        if (siteCountryDescription)
          newWindFarm.siteCountryDescription = siteCountryDescription.toString();
        if (siteAreaDescription)
          newWindFarm.siteAreaDescription = siteAreaDescription.toString();
        if (siteCountryCode)
          newWindFarm.siteCountryCode = siteCountryCode.toString();
        if (
          !windFarmsCreated.find(
            (x) => x.plantUnitId === newWindFarm.plantUnitId
          )
        ) {
          setwindFarmsCreated([...windFarmsCreated, newWindFarm]);
        }
      } else {
        addToast({
          status: 'danger',
          message: 'Windfarm already added',
        });
      }
    } else {
      addToast({
        status: 'warning',
        message: t('Complete all required inputs'),
      });
    }
  }

  function deleteNewEntryWindFarm(id: string | void) {
    setwindFarmsCreated(
      windFarmsCreated.filter(
        (e: TaxonomyCustomerAdmin) => e.plantUnitDescription !== id
      )
    );
    addToast({
      status: 'ok',
      message: t('WindFarm_successfully_deleted'),
    });
  }

  const columnsWindFarm: any[] = [
    {
      Header: t('Company'),
      accessor: 'companyName',
    },
    {
      Header: t('Country'),
      accessor: 'siteCountryDescription',
    },
    {
      Header: t('Wind_farm_id'),
      accessor: 'plantUnitId',
    },
    {
      Header: t('Wind_farm_description'),
      accessor: 'plantUnitDescription',
    },
    {
      Header: '',
      accessor: 'Action',
      disableSortBy: true,

      Cell: ({
        row: {
          original: { plantUnitDescription },
        },
      }: any) => {
        return (
          <div>
            <IconTrash
              onClick={() => deleteNewEntryWindFarm(plantUnitDescription)}
              className={style.cursorPointer}
            />
          </div>
        );
      },
    },
  ];

  const columnsTurbine: any[] = [
    {
      Header: t('Company'),
      accessor: 'companyName',
    },
    {
      Header: t('Country'),
      accessor: 'siteCountryDescription',
    },
    {
      Header: t('Wind_Farm'),
      accessor: 'plantUnitDescription',
    },
    {
      Header: t('Turbine'),
      accessor: 'sectionSystemId',
    },
    {
      Header: t('Model'),
      accessor: 'systemModel',
    },
    {
      Header: t('Status'),
      accessor: 'systemInfoStatus',
    },
  ];

  function validatePlantFields() {
    let toReturn = true;
    const patternValidation = new RegExp(/^[0-9]{1,15}([.?]\d{0,15})?$/);
    const charactersValidation = new RegExp(/[a-zA-Z]/g);

    if (plantCapacity) {
      const plantCapacityMatchRegex = patternValidation.test(
        plantCapacity?.toString() || ''
      );

      if (!plantCapacityMatchRegex) {
        if (charactersValidation.test(plantCapacity.toString() || '')) {
          addToast({
            status: 'warning',
            message: t('plant_capacity_only_numbers'),
          });
        } else {
          addToast({
            status: 'warning',
            message: t('plant_capacity_validation'),
          });
        }

        toReturn = false;
      }
    }

    if (plantContribution) {
      const plantContributionMatchRegex = patternValidation.test(
        plantContribution?.toString() || ''
      );

      if (!plantContributionMatchRegex) {
        if (charactersValidation.test(plantContribution.toString() || '')) {
          addToast({
            status: 'warning',
            message: t('plant_contribution_only_numbers'),
          });
        } else {
          addToast({
            status: 'warning',
            message: t('plant_contribution_validation'),
          });
        }

        toReturn = false;
      }
    }

    return toReturn;
  }

  function validateForm() {
    let toReturn = true;

    if (
      industryName === undefined ||
      industryName === null ||
      industryName === ''
    ) {
      setIndustryValidationColor(true);
      toReturn = false;
    } else {
      setIndustryValidationColor(false);
    }

    if (!ownerName || ownerName === '' || ownerName === undefined) {
      setOwnerNameValidationColor(true);
      toReturn = false;
    } else {
      setOwnerNameValidationColor(false);
    }

    if (!ownerId || ownerId === '' || ownerId === undefined) {
      setOwnerIDValidationColor(true);
      toReturn = false;
    } else {
      setOwnerIDValidationColor(false);
    }

    if (
      !siteCountryCode ||
      siteCountryCode === '' ||
      siteCountryCode === undefined
    ) {
      setSiteCountryCodeValidationColor(true);
      toReturn = false;
    } else {
      setSiteCountryCodeValidationColor(false);
    }

    if (
      !siteCountryDescription ||
      siteCountryDescription === '' ||
      siteCountryDescription === undefined
    ) {
      setSiteCountryDescriptionValidationColor(true);
      toReturn = false;
    } else {
      setSiteCountryDescriptionValidationColor(false);
    }

    if (
      !siteAreaDescription ||
      siteAreaDescription === '' ||
      siteAreaDescription === undefined
    ) {
      setSiteAreaDescriptionValidationColor(borderError);
      toReturn = false;
    } else {
      setSiteAreaDescriptionValidationColor(borderOk);
    }

    if (!plantId || plantId === '' || plantId === undefined) {
      setplantIdValidationColor(borderError);
      toReturn = false;
    } else {
      setplantIdValidationColor(borderOk);
    }
    if (
      !plantDescription ||
      plantDescription === '' ||
      plantDescription === undefined
    ) {
      setPlantDescriptionValidationColor(borderError);
      toReturn = false;
    } else {
      setPlantDescriptionValidationColor(borderOk);
    }

    return toReturn;
  }

  const disableSaveButton = !taxonomy && windFarmsCreated.length <= 0;

  return (
    <FullscreenModal onClose={onClickClose} className={style.modal}>
      <ModalHeader onClose={onClickClose}>
        {!taxonomy
          ? t('Add_New_WindFarm')
          : t('Modify') + ' ' + taxonomy?.plantUnitDescription}
      </ModalHeader>
      <ModalContent className={style.content}>
        <>
          <Loader center show={isFetching} className={style.loader} />
          <div className={isFetching ? style.blur : ''}>
            <div className={taxonomy ? style.containerModify : style.container}>
              <SelectInputSearch
                isDisabled={taxonomy ? true : false}
                error={industryValidationColor}
                placeHolder={'Industry Name'}
                value={industryName}
                options={IndustryOptions}
                onSelectedItemChanged={(e) => handleIndustry(e?.value)}
              />
              {taxonomy ? (
                <div></div>
              ) : (
                <ButtonPrimary outline onClick={AddWindfarmButtonClick}>
                  {t('add_windfarm')}
                </ButtonPrimary>
              )}
              {newOwnerBool ? (
                <div className={style.conatinerColums}>
                  <Input
                    style={plantContriburionMarginValidationColor}
                    placeholder={'Owner Name'}
                    value={ownerName}
                    onChange={(e) => setOwnerName(e)}
                    maxLength={60}
                  />
                  <Input
                    style={plantContriburionMarginValidationColor}
                    placeholder={'Owner ID'}
                    value={ownerId}
                    onChange={(e) => setOwnerId(e)}
                    maxLength={10}
                  />
                  <SelectInputSearch
                    error={siteCountryCodeValidationColor}
                    placeHolder={'Site Country Code'}
                    value={siteCountryCode}
                    options={siteCountryCodeOptions}
                    onSelectedItemChanged={(e) =>
                      handleSiteCountryCode(e?.value)
                    }
                  />
                  <SelectInputSearch
                    error={siteCountryDescriptionValidationColor}
                    placeHolder={'Site Country Description'}
                    value={siteCountryDescription}
                    options={siteCountryDescriptionOptions}
                    onSelectedItemChanged={(e) =>
                      handleSiteCountryDescription(e?.value)
                    }
                  />
                </div>
              ) : (
                <div className={style.conatinerColums}>
                  <SelectInputSearch
                    isDisabled={
                      industryName === '' ||
                      industryName === undefined ||
                      ownerNameOptions.length <= 0
                    }
                    error={ownerNameValidationColor}
                    placeHolder={'Owner Name'}
                    value={ownerName}
                    options={ownerNameOptions}
                    onSelectedItemChanged={(e) => handleOwnerName(e?.value)}
                  />
                  <SelectInputSearch
                    isDisabled={
                      industryName === '' ||
                      industryName === undefined ||
                      ownerIdOptions.length <= 0
                    }
                    error={ownerIdValidationColor}
                    placeHolder={'Owner ID'}
                    value={ownerId}
                    options={ownerIdOptions}
                    onSelectedItemChanged={(e) => handleOwnerId(e?.value)}
                  />
                  <SelectInputSearch
                    error={siteCountryCodeValidationColor}
                    placeHolder={'Site Country Code'}
                    value={siteCountryCode}
                    options={siteCountryCodeOptions}
                    onSelectedItemChanged={(e) =>
                      handleSiteCountryCode(e?.value)
                    }
                  />
                  <SelectInputSearch
                    error={siteCountryDescriptionValidationColor}
                    placeHolder={'Site Country Description'}
                    value={siteCountryDescription}
                    options={siteCountryDescriptionOptions}
                    onSelectedItemChanged={(e) =>
                      handleSiteCountryDescription(e?.value)
                    }
                  />
                </div>
              )}
              {!taxonomy ? (
                newOwnerBool ? (
                  <ButtonPrimary
                    outline
                    onClick={() => setNewOwnerBool(!newOwnerBool)}
                  >
                    {'Exist Owner'}
                  </ButtonPrimary>
                ) : (
                  <ButtonPrimary
                    outline
                    onClick={() => setNewOwnerBool(!newOwnerBool)}
                  >
                    {'New Owner'}
                  </ButtonPrimary>
                )
              ) : (
                <div className={style.conatinerColum}></div>
              )}
              <Input
                style={siteAreaDescriptionValidationColor}
                disabled={true}
                placeholder={'Site Area Description'}
                value={siteAreaDescription}
              />
              <div></div>
              <div className={style.conatinerColums}>
                <Input
                  style={plantIdValidationColor}
                  placeholder={'Plant ID'}
                  value={plantId}
                  onChange={(e) => handlePlantId(e)}
                  maxLength={40}
                />
                <Input
                  style={plantDescriptionValidationColor}
                  placeholder={'Plant Description'}
                  value={plantDescription}
                  onChange={(e) => handlePlantDescription(e)}
                  maxLength={40}
                />
                <Input
                  type="text"
                  style={plantCapacityValidationColor}
                  placeholder={'Plant Capacity'}
                  value={plantCapacity}
                  onChange={(e) => setPlantCapacity(e)}
                  maxLength={31}
                />
                <Input
                  type="text"
                  style={plantContriburionMarginValidationColor}
                  placeholder={'Plant contribution margin'}
                  value={plantContribution}
                  onChange={(e) => setPlantContribution(e)}
                  maxLength={31}
                />
              </div>
            </div>
            <DataTable
              columns={taxonomy ? columnsTurbine : columnsWindFarm}
              data={taxonomy && _turbines ? _turbines : windFarmsCreated}
              className={style.table}
              pagination={31}
            />
            <div className={style.navigation}>
              <ButtonPrimary onClick={onClickClose} outline>
                {t('Cancel')}
              </ButtonPrimary>
              <ButtonPrimary
                onClick={taxonomy ? modifyWindFarms : createWindFarms}
                outline
                disabled={disableSaveButton}
              >
                {t('Save')}
              </ButtonPrimary>
            </div>
          </div>
        </>
      </ModalContent>
    </FullscreenModal>
  );
};
